import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatabaseConnection } from './database-connection';

@Injectable({
  providedIn: 'root',
})
export class DocumentDetailsService {
  constructor(private http : HttpClient, private  dbConnection : DatabaseConnection){}

  documentDetails(state : string, date : any, tab : string){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + `document-details?state=${state}&tab=${tab}&debut=${date.date_debut}&fin=${date.date_fin}`)
  }
}
